    import Product, {
    crossSellItems,
    computeCurrentlyVisibleImage,
    closeAllOpenMenus,
} from './product/detail';
// import findinstore from './product/findinstore';
import {processInclude, enqueueTask} from './util/common';
import {newModalFromString, newModalFromSelector} from './components/modal';
import productSlider from './components/productSlider';
import ScalaPay from 'product/scalaPay';
import Klarna from 'product/klarna';
var debounce = require('lodash/debounce');
var slideIndex = 0;

function setupZoomHandler(elm) {
    var hammertime = new Hammer(elm, {});
    hammertime.get('pinch').set({
        enable: true,
    });
    let posX = 0;
    let posY = 0;
    let scale = 1;
    let lastScale = 1;
    let lastPosX = 0;
    let lastPosY = 0;
    let maxPosX = 0;
    let maxPosY = 0;
    let transform = '';
    let el = elm;

    hammertime.on('doubletap pan pinch panend pinchend', function (ev) {
        if (ev.type === 'doubletap') {
            transform = 'translate3d(0, 0, 0) ' + 'scale3d(2, 2, 1) ';
            scale = 2;
            lastScale = 2;
            try {
                if (
                    window
                        .getComputedStyle(el, null)
                        .getPropertyValue('-webkit-transform')
                        .toString() != 'matrix(1, 0, 0, 1, 0, 0)'
                ) {
                    transform = 'translate3d(0, 0, 0) ' + 'scale3d(1, 1, 1) ';
                    scale = 1;
                    lastScale = 1;
                }
            } catch (err) {}
            el.style.webkitTransform = transform;
            transform = '';
        }

        // pan
        if (scale !== 1) {
            posX = lastPosX + ev.deltaX;
            posY = lastPosY + ev.deltaY;
            maxPosX = Math.ceil(((scale - 1) * el.clientWidth) / 2);
            maxPosY = Math.ceil(((scale - 1) * el.clientHeight) / 2);
            if (posX > maxPosX) {
                posX = maxPosX;
            }
            if (posX < -maxPosX) {
                posX = -maxPosX;
            }
            if (posY > maxPosY) {
                posY = maxPosY;
            }
            if (posY < -maxPosY) {
                posY = -maxPosY;
            }
        }

        // pinch
        if (ev.type === 'pinch') {
            scale = Math.max(0.999, Math.min(lastScale * ev.scale, 4));
        }
        if (ev.type === 'pinchend') {
            lastScale = scale;
        }

        // panend
        if (ev.type === 'panend') {
            lastPosX = posX < maxPosX ? posX : maxPosX;
            lastPosY = posY < maxPosY ? posY : maxPosY;
        }

        if (scale !== 1) {
            transform =
                'translate3d(' +
                posX +
                'px,' +
                posY +
                'px, 0) ' +
                'scale3d(' +
                scale +
                ', ' +
                scale +
                ', 1)';
        }

        if (transform) {
            el.style.webkitTransform = transform;
        }
    });
}

class FixedBarSecondary {
    constructor() {
        this.ticking = false;
        this.fixedElement = '';
        this.scrollStopperElement = '';
    }

    init(fixedElement, additionalBar, sliderTrack, stopperElement, stopperElement2) {
        const fixedHTMLElement = document.getElementById(fixedElement);
        if (!fixedHTMLElement) {
            return;
        }

        const additionalBarHTML = document.getElementById(additionalBar);
        if (!additionalBarHTML) {
            return;
        }

        const sliderTrackHTML = document.getElementById(sliderTrack);
        if (!sliderTrackHTML) {
            return;
        }

        const computedPosition = window.getComputedStyle(fixedHTMLElement).position;
        if (computedPosition === 'sticky') {
            $(fixedHTMLElement).unwrap();
            return;
        }

        this.fixedElement = fixedElement;
        this.additionalBar = additionalBar;
        this.scrollStopperElement = stopperElement;
        this.scrollStopperElement2 = stopperElement2;
        this.sliderTrack = sliderTrack;

        fixedHTMLElement.style.position = 'fixed';
        fixedHTMLElement.style.bottom = null;
        fixedHTMLElement.style.top = null;
        fixedHTMLElement.style.left = null;
        fixedHTMLElement.style.right = null;
        fixedHTMLElement.style.marginTop = null;
        fixedHTMLElement.style.marginLeft = '0';
        fixedHTMLElement.style.zIndex = '995';

        additionalBarHTML.style.position = 'fixed';
        additionalBarHTML.style.marginLeft = '0';
        additionalBarHTML.style.bottom = '0';
        additionalBarHTML.style.zIndex = '995';

        $('.overlay-pdp-mobile').css('z-index', '900');

        window.addEventListener('scroll', this.onScroll.bind(this));
    }

    onScroll() {
        this.requestTick();
    }

    update() {
        this.ticking = false;

        const bottomBar = document.getElementById(this.fixedElement);
        const additionalBar = document.getElementById(this.additionalBar);
        const stopper = document.getElementById(this.scrollStopperElement);
        const stopper2 = document.getElementById(this.scrollStopperElement2);

        const sliderTrack = document.getElementById(this.sliderTrack);

        bottomBar.style.position = 'fixed';
        bottomBar.style.bottom = null;
        bottomBar.style.top = null;
        bottomBar.style.left = null;
        bottomBar.style.right = null;
        bottomBar.style.marginTop = null;
        bottomBar.style.marginLeft = '0';
        bottomBar.style.zIndex = '995';

        additionalBar.style.position = 'fixed';
        additionalBar.style.marginLeft = '0';
        additionalBar.style.bottom = '0';
        additionalBar.style.zIndex = '995';

        $('.overlay-pdp-mobile').css('z-index', '900');

        const r1 = bottomBar.getBoundingClientRect();
        const r2 = stopper.getBoundingClientRect();

        const r3 = additionalBar.getBoundingClientRect();
        const r4 = stopper2.getBoundingClientRect();

        if (r1.bottom > r2.bottom + r3.height) {
            bottomBar.style.position = 'absolute';

            bottomBar.style.left = '0';
            bottomBar.style.right = '0';

            bottomBar.style.bottom = '-2rem';

            sliderTrack.style.display = 'none';

            additionalBar.style.zIndex = '996';
            $('.overlay-pdp-mobile').css('z-index', '996');

            // Additional Bar
            if (r3.bottom > r4.bottom) {
                additionalBar.style.position = 'relative';
                additionalBar.style.bottom = '18px';
            }
        } else {
            sliderTrack.style.display = 'block';
        }
    }

    requestTick() {
        if (!this.ticking) {
            window.raf(this.update.bind(this));
        }
        this.ticking = true;
    }
}

const fixedBarDescription = new FixedBarSecondary();

let automaticScroll = false;
let show = false;

function scrollToTop() {
    // QA-2326 - avoid scrolling on quick add/view
    if ($('.quickview-modal').length > 0) {
        return;
    }

    if (Foundation.MediaQuery.atLeast('medium')) {
        $('html').animate(
            {
                scrollTop: 0,
            },
            400
        );
        return;
    }

    automaticScroll = true;
    $('.primary-images')[0].scrollIntoView({
        behavior: 'smooth',
    });
}

// Moves around in page the picker contents for
function updatePickableContentPositioning() {
    /*
    let mobileContainer = $('.js-pickable-content-mobile-container');
    let desktopContainer = $('.js-pickable-content-desktop-container');
    mobileContainer.removeClass('hide');

    if (Foundation.MediaQuery.atLeast('medium')) {
        if (mobileContainer.children().length > 0) {
            // Move to desktop container
            mobileContainer.children().detach().appendTo(desktopContainer);
        }
    } else {
        if (desktopContainer.children().length > 0) {
            // Move to mobile container
            desktopContainer.children().detach().appendTo(mobileContainer);
        }
    }
    */
}

function masterProduct() {
    var selectedProductColor = $('.color-variation .selected');
    var productColor = $('.color-variation');
    if (selectedProductColor.length === 0 && productColor.length > 0) {
        productColor.first().trigger('click');
    }
}

function adjustCloseIcon(closeIcon) {
    return closeIcon.css({
        top: 0,
        right: 0,
        width: window.innerWidth + 'px',
        'font-size': (window.innerWidth * 10) / 100 + 'px',
        padding: (window.innerWidth * 2) / 100 + 'px ' + (window.innerWidth * 5) / 100 + 'px 0 0',
    });
}

const hideServiceMenuAfterTimeout = function () {
    $('nav[role="navigation"]').removeClass('show');
    $('.icon-container').removeClass('at-top');
    $('.js-breadcrumb').removeClass('show');
};

document.addEventListener('DOMContentLoaded', () => {
    processInclude(require('./findYourSize/findYourSize'));
    processInclude(require('./product/wishlistHeart'));
    Product.run();
    initCalloutMessage();
    // findinstore.run();
    ScalaPay.run();
    Klarna.loadKlarnaWidgetAndObservers();

    // Start window observers for containers
    updatePickableContentPositioning();
    masterProduct();
    $(window).resize(updatePickableContentPositioning);
    // Add to cart sticky
    addToCartSticky();
    showAllColorsButton();
    getInitalProductColorVariant();

    if (!Foundation.MediaQuery.atLeast('medium')) {
        fixedBarDescription.init(
            'descriptionSidebar',
            'menuSelectBarMobile',
            'bottomSpacer2',
            'bottomSpacer3'
        );
    }
    // Enqueue non critical task to be executed after DOMContentLoaded
    enqueueTask(productSlider);

    document.querySelectorAll('.js-offset-anchor').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();
            const targetElement = document.querySelector(this.getAttribute('href'));
            const offset = $('.js-pdpStickyBar').outerHeight() * 1.2;
            window.scrollTo({
                top: targetElement.offsetTop - offset,
                behavior: 'smooth'
            });
        });
    });

    let _lazyloadCache = {};
    function lazyload($domElement) {
        if (!$domElement.hasClass('js-lazyload')) {
            return new Promise(function (resolve, reject) {
                resolve('');
            });
        }
        let url = $domElement.data('lazyurl');
        if (!url) {
            return new Promise(function (resolve, reject) {
                reject(new Error('data-lazyurl not provided'));
            });
        }
        if (_lazyloadCache[url]) {
            return new Promise(function (resolve, reject) {
                resolve(_lazyloadCache[url]);
            });
        }
        return $.ajax(url).then(function (data) {
            _lazyloadCache[url] = data;
            return data;
        });
    }

    // Modal PDP Find Your Size
    $('.js-linkModalFindYourSize').on('click', function (e) {
        e.preventDefault();
        lazyload($(e.currentTarget)).then(function (data) {
            // create and open confirmation modal
            const modal = newModalFromString(data, '', ['cc-findYourSizeModal']);
            $(modal.modalBox).addClass('rightModalAttribute rightModalAttribute_sizeMedium');
            modal.open();

            $('.js-findYourSizeModal-close').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
        });
    });

    $('body').on('click', '.js-find-in-store-btn', (e) => {
        e.preventDefault();
        const isBopisFlow = $(e.currentTarget).closest('.js-bopis-box').length > 0;
        openSizeSelectorModal(e, isBopisFlow);
    });

    $('body').on('click', '.js-bopis-box', function (e) {
        const $anchor = $(this).find('.js-find-in-store-btn');
        
        if (!$anchor.length || $anchor.is(':hidden')) return;

        if ($(e.target).closest('.js-find-in-store-btn').length) {
            return; 
        }
        e.preventDefault();
        $anchor.trigger('click');
    });

    $('body').on('click', '.js-linkModalFindYourSizePlp', function (e) {
        e.preventDefault();
        const htmlContent = $('.js-ModalFindYourSizePlp').html();
        // create and open confirmation modal
        const modal = newModalFromString(htmlContent, false);
        $(modal.modal).addClass('wrapperModalFindYourSizePlp');
        modal.open();
        $(modal.modalBox)
            .find('.close')
            .on('click', function (e) {
                modal.close();
            });

        $('.js-inside-close-modal, #continue-shopping').on('click', function (e) {
            e.preventDefault();
            modal.close();
        });

        $('[data-dismiss="modalBigContent"]').on('click', function (e) {
            e.preventDefault();
            modal.close();
        });
    });

    $('body').on('click', '.js-modal-made-in', function (e) {
        e.preventDefault();
        const _openModal = (modalContent) => {
            const modal = newModalFromString(modalContent, false, [
                'ca-madeInModal',
                'js-madeInModal',
            ]);
            $(modal.modalBox).addClass('rightModalAttribute rightModalAttribute_sizeMedium');
            modal.open();
            $(modal.modalBox).find('.js-madeInModal-close').removeClass('show-for-large');
            $(modal.modalBox)
                .find('.js-madeInModal-close, .js-madeInModal-back')
                .on('click', function (e) {
                    if (Foundation.MediaQuery.atLeast('large')) {
                        $(modal.modalBox)
                            .addClass('cc-modalClosing')
                            .on(
                                'transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd',
                                function () {
                                    modal.close();
                                }
                            );
                    } else {
                        modal.close();
                    }
                });
            $('.js-inside-close-modal,.js-close-modal').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
        };
        lazyload($(e.currentTarget)).then(function (data) {
            _openModal(data.content);
        });
    });

    enqueueTask(function () {
        crossSellItems(decodeURIComponent($('.container').data('pid')));
    });
    computeCurrentlyVisibleImage();

    window.addEventListener('scroll', computeCurrentlyVisibleImage.bind(this));

    let previousPosition = 0;
    let timer;

    const headerHeight = $('.js-mainHeader').outerHeight();
    /*
     * Logic to show/hide the various bars on scroll:
     * - at page top: show both header and service menu
     * - when scrolling up: show only service menu
     * - when scrolling down: do not show anything
     * This logic must not be applied when the scroll is automatic
     */
    const onScrollFunction = function () {
        if (automaticScroll === true) {
            automaticScroll = false;
            return;
        }
        if (timer) {
            clearTimeout(timer);
        }

        const scrollYPos = window.scrollY;
        const scrollYMaxDeadzone =
            (document.documentElement.scrollHeight - document.documentElement.clientHeight) * 0.95;
        const $mainHeader = $('.js-mainHeader-container');
        const $breadCrumbsContainer = $('.js-breadcrumb');

        showStickyBottomBarMobile();

        if (scrollYPos === 0) {
            $mainHeader.addClass('cc-isVisible');
            $breadCrumbsContainer.addClass('cc-isVisible');
            show = true;
        } else if (scrollYPos > headerHeight && !show) {
            if (scrollYPos < previousPosition && scrollYPos < scrollYMaxDeadzone) {
                timer = setTimeout(hideServiceMenuAfterTimeout, 5000);
                $mainHeader.addClass('cc-isVisible');
                $breadCrumbsContainer.addClass('cc-isVisible');
                show = true;
            } else {
                $mainHeader.removeClass('cc-isVisible');
                $breadCrumbsContainer.removeClass('cc-isVisible');
            }
        }
        previousPosition = window.scrollY;
    };

    if (Foundation.MediaQuery.is('large')) {
        $(document).on('click', '.productImageCarouselItem', function (e) {
            $('html').css({'overflow-y': 'hidden'});

            var n = parseInt($(this).attr('data-index'));
            var modal = document.getElementById('zoomModal');
            $(modal).find('.js-zoomModal-imagesWrapper').addClass('loaded');
            modal.classList.add('opened');
            showSlides((slideIndex = n));
            setTimeout(function loaded() {
                $(modal).find('.js-zoomModal-imagesWrapper').addClass('loaded');
            }, 1000)
        });
        $('.js-next-image').on('click', (e) => {
            showSlides((slideIndex += 1));
        });
        $('.js-prev-image').on('click', (e) => {
            showSlides((slideIndex -= 1));
        });
        $('.js-zoomModal-close').on('click', (e) => {
            $('html').css({'overflow-y': ''});
            var modal = document.getElementById('zoomModal');
            modal.classList.remove('opened');
            $(modal).find('.js-zoomModal-imagesWrapper').removeClass('loaded');
            $('.js-images-slide').removeClass('zoomed');
        });
        $('body').on('click', '.js-zoomModal-zoom:not(zoomed), .js-images-slide:not(zoomed)', function (e) {
            var zoomInLabel = $('.js-zoomModal-zoom').attr('data-label-zoom-in');
            var zoomOutLabel = $('.js-zoomModal-zoom').attr('data-label-zoom-out');
            $('body').on('click', '.js-zoomModal-zoom.zoomed, .js-zoomModal-close, .js-images-slide.zoomed', function () {
                $('.js-zoomModal-zoom').removeClass('zoomed').attr('aria-label', zoomInLabel);
                $('.js-images-slide').removeClass('zoomed');
                $('.js-images-slide.js-active').off('mousemove', mouseZoomOnImage);

                $('.js-images-slide').css('marginTop', '');
            });
            $('.js-zoomModal-zoom').addClass('zoomed').attr('aria-label', zoomOutLabel);
            $('.js-images-slide').addClass('zoomed');
            mouseZoomOnImage(e);
            $('body').on('mousemove', '.js-images-slide.js-active', mouseZoomOnImage);
        });
    }

    if ($('.js-intProductDetail').length) {
        automaticScroll = true;

        // modal tap image only mobile
        if (!Foundation.MediaQuery.is('large')) {
            $('.js-linkModalProductImageCarousel').on('click', function (e) {
                var n = parseInt($(this).attr('data-index'));
                $('html').css({'overflow-y': 'hidden'});

                var n = parseInt($(this).attr('data-index'));
                var modal = document.getElementById('zoomModal-mobile');
                modal.classList.add('opened');
                showSlides(slideIndex = n, true);
                setTimeout(function loaded() {
                    $(modal).find('.js-zoomModalMobile-imagesWrapper').addClass('loaded');
                }, 1000)
            });
            $('.js-next-image').on('click', e => {
                showSlides(slideIndex += 1, true);
            });
            $('.js-prev-image').on('click', e => {
                showSlides(slideIndex -= 1, true);
            });
            $('.js-zoomModalMobile-close').on('click', e => {
                $('html').css({'overflow-y': ''});
                var modal = document.getElementById('zoomModal-mobile');
                $(modal).find('.js-zoomModal-imagesWrapper').removeClass('loaded');
                modal.classList.remove('opened');
                $('.js-images-slide').removeClass('zoomed');
            });
            $('body').on('click', '.js-zoomModalMobile-zoom:not(zoomed), .js-images-slide:not(zoomed)', function (e) {
                var zoomInLabel = $('.js-zoomModalMobile-zoom').attr('data-label-zoom-in');
                var zoomOutLabel = $('.js-zoomModalMobile-zoom').attr('data-label-zoom-out');
                $('body').on('click', '.js-zoomModalMobile-zoom.zoomed, .js-zoomModalMobile-close, .js-images-slide.zoomed', function () {
                    $('.js-zoomModalMobile-zoom').removeClass('zoomed').attr('aria-label', zoomInLabel);
                    $('.js-images-slide').removeClass('zoomed');
                });
                $('.js-zoomModalMobile-zoom').addClass('zoomed').attr('aria-label', zoomOutLabel);
                $('.js-images-slide').addClass('zoomed');
            });

            /* Sticky bottom bar in mobile version */
            const addToCartCTA = $('.js-addToCartWrapper');
            const addToCartStickyBar = $('.js-addToCartStickyBar');
            const sizeButton = $('.js-sizeBox-openPanel');
            const paymentWidgets = $('.js-payment-widgets');

            $(addToCartStickyBar).append(
                $(sizeButton).clone(true),
                $(addToCartCTA).clone(true),
                $(paymentWidgets).clone(true).removeClass('hide-for-small-only')
            );
            showStickyBottomBarMobile();
        }

        window.onscroll = () => {
            onScrollFunction();
        };
    }

    $(document).on('product:afterAttributeSelect', (evt, data) => {
        if (data.type === 'color') {
            if ($('.page[data-action="Product-Show"]').length > 0) {
                closeAllOpenMenus();
                scrollToTop();
            }
            if ($(data.container).hasClass('product-freegift')) {
                data.data.product.isFreeGist = true;
            }
            $('body').trigger('product:didChangeColorForProductDetails', data.data.product); // For analytics

        }
    });

    // Scroll images on miniature click
    $('body').on('click', '#miniatureVerticalImgRealContainer .slide', (e) => {
        scrollToTop();
    });
});

function mouseZoomOnImage(e) {
    var pageH = window.innerHeight;
    var imgH = $('.js-images-slide.js-active').height();
    var position = e.clientY;
    var off = -(imgH - pageH) * (position / pageH);
    if (e.originalEvent.type === 'mousemove') {
        $(this).css({
            marginTop: off + 'px',
        });
    } else if (e.originalEvent.type === 'click') {
        $('.js-images-slide.js-active')[0].style.marginTop = off + 'px';
    }
}

function showStickyBottomBarMobile() {
    /* Sticky bottom bar in mobile version */
    const addToCartCTA = $('.js-page-size-box');
    const addToCartStickyBar = $('.js-addToCartStickyBar');
    const addToCartCTATop = $(addToCartCTA).offset().top;
    const addToCartCTABottom = addToCartCTATop + $(addToCartCTA).outerHeight();
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    const isFooterHidden = $(window).scrollTop() + $(window).height() > $('.js-footer').offset().top;

    if ((addToCartCTABottom > viewportTop && addToCartCTATop < viewportBottom) || isFooterHidden) {
        $(addToCartStickyBar).css({
            bottom: '-' + $(addToCartStickyBar).outerHeight() + 'px',
            transition: 'all 0.5s ease',
        });
    } else {
        $(addToCartStickyBar).css({bottom: '0', transition: 'all 0.5s ease'});
    }
}

function initCalloutMessage() {
    var $banner = $('.js-pdpCalloutBanner');
    var $toggle = $('.js-pdpCalloutToggle');
    var $imageContainer = $('.cc-intProductDetail-images-container');
    
    if (!$banner.length) return;

    $imageContainer.addClass('has-callout-banner');

    if (!$toggle.length) return;

    var $text = $banner.find('.cc-pdpCalloutBanner-text');

    if (!isTextOverflowing($text)) {
        $toggle.remove();
        return;
    }

    function expandBanner() {
        $banner.addClass('expanded');
        $toggle.attr('aria-expanded', true);
    }

    function collapseBanner() {
        $banner.removeClass('expanded');
        $toggle.attr('aria-expanded', false);
    }

    function isTextOverflowing($element) {
        let extendableBanner = false;
        $element.each(function () {
            const el = this;
            if (el.clientHeight > 0) {
                const heightOverflow = el.scrollHeight - el.clientHeight;
                const widthOverflow = el.scrollWidth - el.clientWidth;
                if (heightOverflow > 1 || widthOverflow > 1) {
                    extendableBanner = true;
                }
            }
        });
        return extendableBanner;
    }

    $toggle.on('click', function () {
        if ($banner.hasClass('expanded')) {
            collapseBanner();
        } else {
            expandBanner();
        }
    });

    $(window).on('scroll touchmove', debounce(function () {
        if ($banner.hasClass('expanded')) {
            collapseBanner();
        }
    }, 400));
}

function showSlides (n, mobile) {
    var zoomModal;

    if (mobile) {
        zoomModal = $('#zoomModal-mobile');
    } else {
        zoomModal = $('#zoomModal');
    }

    var length = parseInt(zoomModal.data('numberOfImages'), 10);
    var slides = $(zoomModal)[0].getElementsByClassName('js-images-slide');

    var slideIndex = (length + (n % length)) % length;
    var prev = (length + ((n - 1) % length)) % length;
    var next = (length + ((n + 1) % length)) % length;

    slides[prev].classList.add('js-prev');
    slides[slideIndex].classList.add('js-active');
    slides[next].classList.add('js-next');

    for (var i = 0; i < length; i++) {
        if (i != slideIndex) {
            slides[i].classList.remove('js-active');
        }
        if (i != prev) {
            slides[i].classList.remove('js-prev');
        }
        if (i != next) {
            slides[i].classList.remove('js-next');
        }
    }

    zoomModal.find('.js-zoomModal-imageCount').html((slideIndex + 1) + '/' + length);

    if (length > 1) {
        $('.prev').removeClass('hidden');
        $('.next').removeClass('hidden');
    } else {
        $('.prev').addClass('hidden');
        $('.next').addClass('hidden');
    }
}

// Modal Smart Gift Rules
$('.js-smart-gift-rules').on('click', function (e) {
    e.preventDefault();
    const htmlContent = $($(this).data('target')).html();
    // create and open confirmation modal
    const modalBigContent = newModalFromString(htmlContent, false);
    modalBigContent.setContent(document.querySelector('.js-smart-gift-rules-modal').innerHTML);
    $('.tingle-modal').addClass('wrapperModal');
    $('.wrapperModal').addClass('smartGiftModal');
    modalBigContent.open();
    $(modalBigContent.modalBox)
        .find('.close')
        .on('click', function (e) {
            modalBigContent.close();
        });

    $('.js-inside-close-modal').on('click', function (e) {
        e.preventDefault();
        modalBigContent.close();
    });

    $('[data-dismiss="modalBigContent"]').on('click', function (e) {
        e.preventDefault();
        modalBigContent.close();
    });

    $('body').on('click', '.check-dispo-store-availability', (e) => {
        $('.js-change-store.find-in-store-btn').trigger('click');
    })
});

// Add to cart sticky
let lastScroll = 0;
function addToCartSticky() {
    $(document).ready(function () {
        $(window).on('scroll', stickyBarManager);
    });
}
function getScrollPosition() {
    let scrollPosition = $(window).scrollTop();
    if ($('.js-mainHeader')) {
        scrollPosition += $('.js-mainHeader').height();
    }
    return scrollPosition;
}
function setCompleteTheLookButtonPosition() {
    if (Foundation.MediaQuery.atLeast('large')) {
        $('.primary-images .complete-look-button').css('top', window.innerHeight - 60);
    }
}
function getCtaPosition() {
    return calculateTopOffset($('.js-page-size-box'));
}
function calculateTopOffset($element) {
    if ($element.length > 0)
        return $element.offset().top + $element.outerHeight();
}
function showStickyBar() {
    $('.js-pdpStickyBar').slideDown({duration: 250});
    $('.js-mainHeader').addClass('visibility-hidden');
}
function hideStickyBar() {
    $('.js-pdpStickyBar').slideUp({duration: 250});
    $('.js-mainHeader').removeClass('visibility-hidden');
}
function showOrHideStickyBar() {
    if (getScrollPosition() >= getCtaPosition()) {
        showStickyBar();
    } else {
        hideStickyBar();
    }
}
function stickyBarManager() {
    showOrHideStickyBar();
}

const video = $('.js-textileBanner-videoContainer-video:visible')[0];
let isPlaying = true;

function togglePlayPause() {
    $('body').on('click', '#js-textileBanner-playPauseButton', function(e) {
        e.preventDefault();
        if (isPlaying) {
            video.pause();
            $('.js-textileBanner-playPauseButton_play').removeClass('hidden');
            $('.js-textileBanner-playPauseButton_pause').addClass('hidden');
        } else {
            video.play();
            $('.js-textileBanner-playPauseButton_pause').removeClass('hidden');
            $('.js-textileBanner-playPauseButton_play').addClass('hidden');
        }
        isPlaying = !isPlaying;
    });
}

function showAllColorsButton() {
    $('.js-show-view-less').on('click', function (e) {
        
        $('.js-add-view-more-background').addClass('js-show-view-more');
        $('.js-view-more-colors-button').addClass('js-show-view-more');
        $('.js-add-view-more-background').removeClass('hide').fadeIn(300);
        $('.js-view-more-colors-button').removeClass('hide').fadeIn(300);
        $('.js-show-view-less').slideUp(300);
        $('.js-hide-more-chips').slideUp(300);
    });
}
togglePlayPause();

$('.js-change-name-on-hover').on('mouseover', function () {
    var attributeValueName = $(this).data('attr-value-name');
    var attributeValueId = $(this).data('attr-value');
    var attributeValueColorFamily = $(this).data('attr-value-color-family');
    $('.js-product-color-name').text(attributeValueColorFamily);
    $('.js-product-color-id').text(' - ' + attributeValueId + ' - ' + attributeValueName.toLowerCase());
});

$('.js-restore-original-color-name').on('mouseleave', function () {
    var initalProductColorShown = window.sessionStorage.getItem('initalProductColorShown');
    var initalProductColorShownId = window.sessionStorage.getItem('initalProductColorShownId');
    var initalProductColorShownColorFamily = window.sessionStorage.getItem('initalProductColorShownColorFamily');
    $('.js-product-color-name').text(initalProductColorShownColorFamily);
    $('.js-product-color-id').text(' - ' + initalProductColorShownId + ' - ' + initalProductColorShown);
});

function getInitalProductColorVariant () {
    var selectedColor = $('.js-restore-original-color-name').find('.selected');
    if (selectedColor && selectedColor.length > 0) {
        window.sessionStorage.setItem('initalProductColorShown', selectedColor.data('attr-value-name'));
        window.sessionStorage.setItem('initalProductColorShownId', selectedColor.data('attr-value'));
        window.sessionStorage.setItem('initalProductColorShownColorFamily', selectedColor.data('attr-value-color-family'));
    }
}

function openSizeSelectorModal(e, isBopisFlow = false) {
    if ($('.fis-select-size-modal').length > 0) {
        return;
    } else {
        const isSizeSelected = () => {
            if ($(e.currentTarget).hasClass('js-find-in-store-btn-notify-me')) {
                // size always selected in plp before cta is clicked
                return true;
            } else {
                return $('[data-attr="size"] input:checked').length > 0 || $('[data-attr="size-mobile"] input:checked').length > 0;
            }
        };

        const selectPreselectedSizes = () => {
            let preselectedSizes = $('.js-stored-preselected-sizes').data('preselected-size');
            let pdpAlreadySelectedSize = $('[data-attr="size"] input:checked').data('size-id') || $('[data-attr="size-mobile"] input:checked').data('size-id');
            let pdpAlreadySelectedSizeString = pdpAlreadySelectedSize ? pdpAlreadySelectedSize.toString() : '';
            if (preselectedSizes.length > 0 && pdpAlreadySelectedSizeString !== preselectedSizes && pdpAlreadySelectedSizeString.length < 1) {
                var arrayPreselectedSizes = preselectedSizes.split('_');
                $('.js-stored-preselected-sizes').data('preselected-size', '');
                for (var i = 0; i < arrayPreselectedSizes.length; i++) {
                    $(".js-store-locatator-size[data-attr-value='" + arrayPreselectedSizes[i] + "']").click();
                }
            }
        }
        let sizeModal = newModalFromSelector('fis-select-size', false, [
            'fis-select-size-modal',
        ]);

        const $sizeModalElement = $(sizeModal.modalBox);
        $sizeModalElement.find('.size-selector').removeAttr('disabled').removeClass('notifyMe');
        $sizeModalElement.find('.notifyIcon').remove();
        $sizeModalElement.on('click', '.modal__closeIcon', (e) => {
            sizeModal.close();
            sizeModal.destroy();
        });

        sizeModal.open();
        $('.js-find-in-store-btn').data('size-value', '');
        $('body.tingle-enabled').css('overflow', 'unset');

        $sizeModalElement.on('click', 'button.size-selector', (e) => {
            const $target = $(e.currentTarget);
            const sizeValue = $(e.currentTarget).data('attr-value');
            var sizeValueString = '';
            if (sizeValue) {
                sizeValueString = sizeValue.toString();
            }
            let selectedSizes = $('.js-find-in-store-btn').data('size-value');
            let preselectedSizes = $('.js-stored-preselected-sizes').data('preselected-size');
            if (selectedSizes && selectedSizes !== '') {
                selectedSizes = selectedSizes.split('_');
            } else {
                selectedSizes = [];
            }

            if (preselectedSizes && preselectedSizes !== '') {
                preselectedSizes = preselectedSizes.split('_');
            } else {
                preselectedSizes = [];
            }


            if ($target.hasClass('selected')) {
                $target.removeClass('selected');
                selectedSizes.splice(selectedSizes.indexOf(sizeValueString), 1);
                preselectedSizes.splice(preselectedSizes.indexOf(sizeValueString), 1);
            } else if ($target.closest('ul').find('button.selected').length < 3) {
                $target.addClass('selected');
                selectedSizes.push(sizeValueString);
                preselectedSizes.push(sizeValueString);
            }
            if ($target.closest('ul').find('button.selected').length === 3) {
                $target.closest('ul').find('button').not('.selected').addClass('disabled');
            } else {
                $target.closest('ul').find('button').not('.selected').removeClass('disabled');
            }

            $('.fis-select-size-modal .find-in-store-size-select-btn').prop(
                'disabled',
                selectedSizes.length === 0
            );
            $('.js-find-in-store-btn').data('size-value', selectedSizes.join('_'));
            $('.js-stored-preselected-sizes').data('preselected-size', preselectedSizes.join('_'));
            e.stopPropagation();
        });

        $sizeModalElement.on('click', '.find-in-store-size-select-btn', (e) => {
            e.stopPropagation();
            $('body').trigger('find-in-store-size-select-btn:click', e);
            __webpack_public_path__ = window.ll_script.base;
            import(/* webpackChunkName: "findinstore" */ './product/rf_findinstore').then(
                (findinstore) => {
                    let fs = findinstore.default;
                    fs.run();
                    $('.findinstore-data-container').data('type', 'Pickup');
                    fs.launch(isBopisFlow);
                    sizeModal.close();
                    sizeModal.destroy();
                }
            );
        });
        $('body').trigger('product:moreInfoToggle', 'find_in_store');
        if ($(e.currentTarget).closest('.notifyMeModal').length === 0) {
            $('body').trigger('product-find-in-store:click', { 'isDispo': $(e.currentTarget).hasClass('analytics-searchNearestStore') });
        }
        if (isSizeSelected()) {
            var pdpSelectedSize = '';
            var desktopSizeSelector = $('[data-attr="size"] input:checked').data('size-id');
            var mobileSizeSelector = $('[data-attr="size-mobile"] input:checked').data('size-id');
            if (desktopSizeSelector && desktopSizeSelector.length > 0) {
                pdpSelectedSize = $('[data-attr="size"] input:checked').data('size-id');
                $(".js-store-locatator-size[data-attr-value='" + pdpSelectedSize + "']").click();
            } else if (mobileSizeSelector && mobileSizeSelector.length > 0) {
                pdpSelectedSize = $('[data-attr="size-mobile"] input:checked').data('size-id');
                $(".js-store-locatator-size[data-attr-value='" + pdpSelectedSize + "']").click();
            }
        }
        selectPreselectedSizes();
    }
};

export {openSizeSelectorModal};